import { useEffect, useState } from 'react';
import api from '@/lib/api';
export default function PublicationPreviewBanner() {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let mounted = true;
    api.get('/preview/status').then(({ data }) => { if (mounted) setEnabled(data.enabled === true); }).catch(() => {});
    return () => { mounted = false; };
  }, []);
  if (!enabled) return null;
  return <div role="status" aria-label="Modo de vista previa" style={{ background: '#fef3c7', color: '#451a03', padding: '8px 16px', textAlign: 'center', fontSize: 13 }}>Vista previa: envíos y tareas automáticas deshabilitados.</div>;
}
